import * as React from 'react';

interface Props {
    mainContent: React.JSX.Element
}

class Ymc extends React.Component<Props> {
    render() {
        return (
            // overflow-auto
            <div
                className="w-full max-w-[1000px] self-stretch inline-flex flex-col justify-start items-start gap-2 overflow-auto"
                style={{
                    maxHeight: 'calc( 100vh - 80px )'
                }}
            >
                {this.props.mainContent}
            </div>
        );
    }
};

export default Ymc;
